import React from 'react';
import PropTypes from 'prop-types';

const Label = React.forwardRef(({ className = "", variant = "default", size = "default", ...props }, ref) => {
    const labelVariants = "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"

  return (
    <label className={` ${labelVariants} ${className} `} ref={ref} {...props} />
  )
})

Label.displayName = "Label";

Label.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  size: PropTypes.string,
  children: PropTypes.node,
  htmlFor: PropTypes.string,
};

Label.defaultProps = {
  className: "",
  variant: "default",
  size: "default",
};

export { Label };